/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

export interface IBusinessSignUpDescriptionProps {
    id: string;
    className: string;
    text: string;
}

export const DescriptionLabel: React.FC<IBusinessSignUpDescriptionProps> = ({ id, className, text }) => {
    return (
        <div
            id={`${id}_description`}
            className='ms-business-sign-up__form-item-label'
            style={{ fontSize: '14px', color: 'gray', display: 'block', marginBottom: '10px' }}
        >
            {text}
        </div>
    );
};

export default DescriptionLabel;
